// @flow

export const ETIOLOGY_LOCATION = "etiologyLocation";
export const ETIOLOGY = "etiology";
export const LOCATIONS = "locations";
export const PATIENTS = "patients";
export const RISKS = "risks";
